import { render, staticRenderFns } from "./TariffPremiumForm.vue?vue&type=template&id=3d91102c&"
import script from "./TariffPremiumForm.vue?vue&type=script&lang=js&"
export * from "./TariffPremiumForm.vue?vue&type=script&lang=js&"
import style0 from "./TariffPremiumForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TariffPremiumForm.vue"
export default component.exports